import * as React from 'react';
import { Notice, cn, scrollToElement } from '@siteground/styleguide';
import { SYSTEM_MESSAGE_TYPES } from '../../../constants';
import { ChatContext } from '../../chat-context';
import Translate from '../../translate/translate';
import './system-message.css';

/**
 * @param {{ message?: string, intlKey?: string, intlValues?: object, className?: string, type?: * }} props
 * @returns {*}
 */
const SystemMessage = ({ message, intlKey, intlValues, className, type }) => {
  const domRef = React.useRef(null);
  const { shouldAutoScroll } = React.useContext(ChatContext);
  const messageToUse = intlKey ? <Translate id={intlKey} {...intlValues} /> : message;

  const classes = cn('sg-system-message', className);

  React.useEffect(() => {
    if (shouldAutoScroll) {
      scrollToElement(domRef.current, { behavior: 'auto', block: 'start', inline: 'nearest' });
    }
  }, []);

  return (
    <div className={classes} ref={domRef}>
      <Notice className="sg-system-message__notice" type={type}>
        {messageToUse}
      </Notice>
    </div>
  );
};

SystemMessage.defaultProps = {
  intlValues: {},
  type: SYSTEM_MESSAGE_TYPES.INSTRUCTION
};

export default SystemMessage;
